// npm install blueimp-md5
import md5 from 'blueimp-md5';

export interface GenerateConfig {
  project: string; // 项目名称，作为所有key的前缀
  isShowKey?: boolean; // 是否显示未录入的key，用于测试录入是否成功
  isDev?: boolean; // 【即将废弃】如果为true，则提示更全面
}

export interface GenerateFunction {
  (label: string, namespace?: string, options?: any): string;
}

interface TransifyKeyParams {
  label: string; // 翻译文案
  project: string; // 项目名称，作为所有key的前缀
  namespace?: string; // key的模块名，默认为other
}

function md516(str: string): string {
  return md5(str).slice(8, 24);
}

// 生成key
export function generateKey({ label, project, namespace }: TransifyKeyParams): string {
  if (!project || !label) return '';
  const computedKey = [project, namespace, label]
    .filter((key) => !!key)
    .join('_')
    .replace(/\s/g, '_');

  return md516(computedKey);
}
